export default __webpack_public_path__ + "static/media/IMG_5018.85bee619.png";